// Pricing per 1M tokens (USD) - updated Jan 2025
// null = free, 0 = negligible/free tier
export const AI_PROVIDERS = {
  openai: {
    id: 'openai',
    name: 'ChatGPT (OpenAI)',
    models: [
      { id: 'gpt-4o-mini', name: 'GPT-4o Mini (Fast & Cheap)', inputCost: 0.15, outputCost: 0.60 },
      { id: 'gpt-4o', name: 'GPT-4o', inputCost: 2.50, outputCost: 10.00 },
      { id: 'gpt-4-turbo', name: 'GPT-4 Turbo', inputCost: 10.00, outputCost: 30.00 },
      { id: 'o1-mini', name: 'o1-mini (Reasoning)', inputCost: 3.00, outputCost: 12.00 }
    ],
    defaultModel: 'gpt-4o-mini',
    keyPlaceholder: 'sk-...',
    keyUrl: 'https://platform.openai.com/api-keys',
    requiresKey: true
  },
  anthropic: {
    id: 'anthropic',
    name: 'Claude (Anthropic)',
    models: [
      { id: 'claude-3-5-haiku-20241022', name: 'Claude 3.5 Haiku (Fast)', inputCost: 0.80, outputCost: 4.00 },
      { id: 'claude-3-5-sonnet-20241022', name: 'Claude 3.5 Sonnet', inputCost: 3.00, outputCost: 15.00 },
      { id: 'claude-sonnet-4-20250514', name: 'Claude Sonnet 4', inputCost: 3.00, outputCost: 15.00 },
      { id: 'claude-opus-4-20250514', name: 'Claude Opus 4 (Best)', inputCost: 15.00, outputCost: 75.00 }
    ],
    defaultModel: 'claude-3-5-haiku-20241022',
    keyPlaceholder: 'sk-ant-...',
    keyUrl: 'https://console.anthropic.com/settings/keys',
    requiresKey: true
  },
  gemini: {
    id: 'gemini',
    name: 'Gemini (Google)',
    models: [
      { id: 'gemini-2.0-flash', name: 'Gemini 2.0 Flash (Fast)', inputCost: 0.10, outputCost: 0.40 },
      { id: 'gemini-1.5-flash', name: 'Gemini 1.5 Flash', inputCost: 0.075, outputCost: 0.30 },
      { id: 'gemini-1.5-pro', name: 'Gemini 1.5 Pro', inputCost: 1.25, outputCost: 5.00 },
      { id: 'gemini-2.0-pro', name: 'Gemini 2.0 Pro (Best)', inputCost: 1.25, outputCost: 5.00 }
    ],
    defaultModel: 'gemini-2.0-flash',
    keyPlaceholder: 'AIza...',
    keyUrl: 'https://aistudio.google.com/app/apikey',
    requiresKey: true
  },
  groq: {
    id: 'groq',
    name: 'Groq (Free)',
    models: [
      { id: 'llama-3.3-70b-versatile', name: 'Llama 3.3 70B', inputCost: 0, outputCost: 0 },
      { id: 'llama-3.1-8b-instant', name: 'Llama 3.1 8B (Fastest)', inputCost: 0, outputCost: 0 },
      { id: 'mixtral-8x7b-32768', name: 'Mixtral 8x7B', inputCost: 0, outputCost: 0 },
      { id: 'gemma2-9b-it', name: 'Gemma 2 9B', inputCost: 0, outputCost: 0 }
    ],
    defaultModel: 'llama-3.3-70b-versatile',
    keyPlaceholder: 'gsk_...',
    keyUrl: 'https://console.groq.com/keys',
    requiresKey: true
  },
  mistral: {
    id: 'mistral',
    name: 'Mistral (Mistral AI)',
    models: [
      { id: 'mistral-small-latest', name: 'Mistral Small (Fast)', inputCost: 0.20, outputCost: 0.60 },
      { id: 'mistral-medium-latest', name: 'Mistral Medium', inputCost: 2.70, outputCost: 8.10 },
      { id: 'mistral-large-latest', name: 'Mistral Large (Best)', inputCost: 2.00, outputCost: 6.00 }
    ],
    defaultModel: 'mistral-small-latest',
    keyPlaceholder: 'API key',
    keyUrl: 'https://console.mistral.ai/api-keys',
    requiresKey: true
  },
  ollama: {
    id: 'ollama',
    name: 'Ollama (Local)',
    models: [
      { id: 'llama3.2', name: 'Llama 3.2', inputCost: 0, outputCost: 0 },
      { id: 'llama3.3', name: 'Llama 3.3', inputCost: 0, outputCost: 0 },
      { id: 'mistral', name: 'Mistral', inputCost: 0, outputCost: 0 },
      { id: 'gemma2', name: 'Gemma 2', inputCost: 0, outputCost: 0 },
      { id: 'qwen2.5', name: 'Qwen 2.5', inputCost: 0, outputCost: 0 },
      { id: 'deepseek-r1', name: 'DeepSeek R1', inputCost: 0, outputCost: 0 },
      { id: 'phi4', name: 'Phi-4', inputCost: 0, outputCost: 0 }
    ],
    defaultModel: 'llama3.2',
    keyPlaceholder: 'http://localhost:11434',
    keyUrl: 'https://ollama.com/download',
    requiresKey: false,
    requiresEndpoint: true
  }
};

// Provider display order for card grid
export const PROVIDER_ORDER = ['openai', 'anthropic', 'gemini', 'groq', 'mistral', 'ollama'];

// --- Storage ---

const V2_STORAGE_KEY = 'timechainstats_ai_providers_v2';
const V1_STORAGE_KEY = 'timechainstats_ai_providers';
const LEGACY_STORAGE_KEY = 'timechainstats_ai_config';

/**
 * Read v2 storage: { active: string|null, keys: { [providerId]: { apiKey, model, endpoint? } } }
 */
const readStore = () => {
  try {
    const raw = localStorage.getItem(V2_STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch (e) {
    console.warn('[AIProviders] Failed to read store:', e.message);
  }
  return { active: null, keys: {} };
};

const writeStore = (store) => {
  try {
    localStorage.setItem(V2_STORAGE_KEY, JSON.stringify(store));
  } catch (e) {
    console.warn('[AIProviders] Failed to write store:', e.message);
  }
};

/**
 * Migrate from v1 multi-provider format or legacy single-provider format to v2
 */
const migrateToV2 = () => {
  try {
    if (localStorage.getItem(V2_STORAGE_KEY)) return; // already migrated

    // Try v1 format first (timechainstats_ai_providers)
    const v1Raw = localStorage.getItem(V1_STORAGE_KEY);
    if (v1Raw) {
      const v1 = JSON.parse(v1Raw);
      const providers = v1.providers || [];
      if (providers.length > 0) {
        const keys = {};
        let active = null;
        for (const p of providers) {
          if (!p.provider || !AI_PROVIDERS[p.provider]) continue;
          const entry = { model: p.model || AI_PROVIDERS[p.provider].defaultModel };
          if (AI_PROVIDERS[p.provider].requiresKey) entry.apiKey = p.apiKey || '';
          if (AI_PROVIDERS[p.provider].requiresEndpoint) entry.endpoint = p.endpoint || 'http://localhost:11434';
          keys[p.provider] = entry;
          // First enabled provider becomes active
          if (!active && p.enabled !== false) active = p.provider;
        }
        if (!active && Object.keys(keys).length > 0) active = Object.keys(keys)[0];
        writeStore({ active, keys });
        localStorage.removeItem(V1_STORAGE_KEY);
        console.log('[AIProviders] Migrated v1 config to v2');
        return;
      }
    }

    // Try legacy single-config format (timechainstats_ai_config)
    const legacyRaw = localStorage.getItem(LEGACY_STORAGE_KEY);
    if (legacyRaw) {
      const legacy = JSON.parse(legacyRaw);
      if (legacy.provider && AI_PROVIDERS[legacy.provider]) {
        const entry = { model: legacy.model || AI_PROVIDERS[legacy.provider].defaultModel };
        if (AI_PROVIDERS[legacy.provider].requiresKey) entry.apiKey = legacy.apiKey || '';
        if (AI_PROVIDERS[legacy.provider].requiresEndpoint) entry.endpoint = legacy.endpoint || 'http://localhost:11434';
        writeStore({ active: legacy.provider, keys: { [legacy.provider]: entry } });
        localStorage.removeItem(LEGACY_STORAGE_KEY);
        console.log('[AIProviders] Migrated legacy config to v2');
      }
    }
  } catch (e) {
    console.warn('[AIProviders] Migration failed:', e.message);
  }
};

// Run migration on load
migrateToV2();

// --- New API ---

/**
 * Get saved key/model for a provider
 * @returns {{ apiKey?: string, model: string, endpoint?: string } | null}
 */
export const getProviderKey = (providerId) => {
  const store = readStore();
  return store.keys[providerId] || null;
};

/**
 * Save key/model for a provider
 */
export const setProviderKey = (providerId, apiKey, model, endpoint) => {
  const store = readStore();
  const entry = { model: model || AI_PROVIDERS[providerId]?.defaultModel };
  if (AI_PROVIDERS[providerId]?.requiresKey) entry.apiKey = apiKey || '';
  if (AI_PROVIDERS[providerId]?.requiresEndpoint) entry.endpoint = endpoint || 'http://localhost:11434';
  store.keys[providerId] = entry;
  // Auto-activate if no active provider
  if (!store.active) store.active = providerId;
  writeStore(store);
};

/**
 * Remove key for a provider
 */
export const clearProviderKey = (providerId) => {
  const store = readStore();
  delete store.keys[providerId];
  if (store.active === providerId) {
    // Pick next available or null
    const remaining = Object.keys(store.keys);
    store.active = remaining.length > 0 ? remaining[0] : null;
  }
  writeStore(store);
};

/**
 * Get active provider ID
 * @returns {string|null}
 */
export const getActiveProvider = () => {
  const store = readStore();
  return store.active;
};

/**
 * Set active provider
 */
export const setActiveProvider = (providerId) => {
  const store = readStore();
  store.active = providerId;
  writeStore(store);
};

// --- Backward-compatible API (used by aiService.js and AIInsightsButton.jsx) ---

/**
 * Build a config object from provider ID + stored key data
 * Shape: { provider, apiKey, endpoint, model } — same as old format
 */
const buildConfig = (providerId) => {
  const providerDef = AI_PROVIDERS[providerId];
  if (!providerDef) return null;
  const stored = getProviderKey(providerId);
  if (!stored) return null;
  return {
    provider: providerId,
    apiKey: stored.apiKey || null,
    endpoint: stored.endpoint || null,
    model: stored.model || providerDef.defaultModel
  };
};

/**
 * Get the active provider's config (backward-compatible)
 * @returns {{ provider, apiKey, endpoint, model } | null}
 */
export const getStoredConfig = () => {
  const store = readStore();
  if (!store.active) return null;
  const config = buildConfig(store.active);
  if (config && isConfigValid(config)) return config;
  // Fallback: first valid provider
  for (const id of Object.keys(store.keys)) {
    const c = buildConfig(id);
    if (c && isConfigValid(c)) return c;
  }
  return null;
};

/**
 * Get all valid configs for fallback iteration
 * @returns {Array<{ provider, apiKey, endpoint, model }>}
 */
export const getValidConfigs = () => {
  const store = readStore();
  const configs = [];
  // Active provider first
  if (store.active && store.keys[store.active]) {
    const c = buildConfig(store.active);
    if (c && isConfigValid(c)) configs.push(c);
  }
  // Then remaining providers
  for (const id of Object.keys(store.keys)) {
    if (id === store.active) continue;
    const c = buildConfig(id);
    if (c && isConfigValid(c)) configs.push(c);
  }
  return configs;
};

/**
 * Check if at least one valid provider is configured
 */
export const hasValidConfig = () => {
  const store = readStore();
  return Object.keys(store.keys).some(id => {
    const c = buildConfig(id);
    return c && isConfigValid(c);
  });
};

/**
 * Check if a specific config object is valid
 */
export const isConfigValid = (config) => {
  if (!config) return false;
  const provider = AI_PROVIDERS[config.provider];
  if (!provider) return false;
  if (provider.requiresKey && !config.apiKey) return false;
  if (provider.requiresEndpoint && !config.endpoint) return false;
  return true;
};

/**
 * Clear all stored configs
 */
export const clearStoredConfig = () => {
  localStorage.removeItem(V2_STORAGE_KEY);
  localStorage.removeItem(V1_STORAGE_KEY);
  localStorage.removeItem(LEGACY_STORAGE_KEY);
};

// --- Cost estimation (unchanged) ---

// Base token estimates (measured from actual prompt content)
const BASE_SYSTEM_TOKENS = 5100;
const ESTIMATED_OUTPUT_TOKENS = 800;

const CATEGORY_TOKEN_ESTIMATES = {
  market: 150,
  network: 200,
  mining: 250,
  lightning: 100,
  activity: 200
};

const calculateInputTokens = (selectedCategories = null) => {
  if (!selectedCategories || selectedCategories.length === 0 || selectedCategories.length === 5) {
    return BASE_SYSTEM_TOKENS + Object.values(CATEGORY_TOKEN_ESTIMATES).reduce((a, b) => a + b, 0);
  }
  const categoryTokens = selectedCategories.reduce((total, cat) => {
    return total + (CATEGORY_TOKEN_ESTIMATES[cat] || 0);
  }, 0);
  return BASE_SYSTEM_TOKENS + categoryTokens;
};

/**
 * Get estimated cost for the active provider
 */
export const getEstimatedCost = (selectedCategories = null) => {
  const config = getStoredConfig();
  if (!config) return null;

  const provider = AI_PROVIDERS[config.provider];
  if (!provider) return null;

  const model = provider.models.find(m => m.id === config.model) ||
                provider.models.find(m => m.id === provider.defaultModel);
  if (!model) return null;

  const { inputCost, outputCost } = model;

  if (inputCost === 0 && outputCost === 0) {
    return { cost: 0, isFree: true, formatted: 'Free', model: model.name, provider: provider.name };
  }

  const inputTokens = calculateInputTokens(selectedCategories);
  const inputTotal = (inputTokens / 1_000_000) * inputCost;
  const outputTotal = (ESTIMATED_OUTPUT_TOKENS / 1_000_000) * outputCost;
  const totalCost = inputTotal + outputTotal;

  let formatted;
  if (totalCost < 0.001) formatted = '<$0.001';
  else if (totalCost < 0.01) formatted = `~$${totalCost.toFixed(4)}`;
  else formatted = `~$${totalCost.toFixed(3)}`;

  return {
    cost: totalCost, isFree: false, formatted,
    model: model.name, provider: provider.name,
    inputTokens, outputTokens: ESTIMATED_OUTPUT_TOKENS
  };
};

/**
 * Get estimated cost for a specific config
 */
export const getEstimatedCostForConfig = (config, selectedCategories = null) => {
  if (!config) return null;

  const provider = AI_PROVIDERS[config.provider];
  if (!provider) return null;

  const model = provider.models.find(m => m.id === config.model) ||
                provider.models.find(m => m.id === provider.defaultModel);
  if (!model) return null;

  const { inputCost, outputCost } = model;
  const inputTokens = calculateInputTokens(selectedCategories);
  const totalTokens = inputTokens + ESTIMATED_OUTPUT_TOKENS;

  if (inputCost === 0 && outputCost === 0) {
    return { cost: 0, isFree: true, formatted: 'Free', inputTokens, outputTokens: ESTIMATED_OUTPUT_TOKENS, totalTokens };
  }

  const inputTotal = (inputTokens / 1_000_000) * inputCost;
  const outputTotal = (ESTIMATED_OUTPUT_TOKENS / 1_000_000) * outputCost;
  const totalCost = inputTotal + outputTotal;

  let formatted;
  if (totalCost < 0.001) formatted = '<$0.001';
  else if (totalCost < 0.01) formatted = `~$${totalCost.toFixed(4)}`;
  else formatted = `~$${totalCost.toFixed(3)}`;

  return { cost: totalCost, isFree: false, formatted, inputTokens, outputTokens: ESTIMATED_OUTPUT_TOKENS, totalTokens };
};
